import { render, staticRenderFns } from "./BiddingCommissionBidInput.vue?vue&type=template&id=38a10ae8"
import script from "./BiddingCommissionBidInput.vue?vue&type=script&lang=js"
export * from "./BiddingCommissionBidInput.vue?vue&type=script&lang=js"
import style0 from "./BiddingCommissionBidInput.vue?vue&type=style&index=0&id=38a10ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports